<template>
  <div class="homePage">
    <header id="header">
      <div class="container">
        <div class="menu-mobile">
          <img src="../../assets/logo.svg" alt="Menu mobile" />
        </div>

        <a href="/" class="header__link">
          <img
            src="../../assets/logo.svg"
            alt="Logo Adapt-e"
            class="logo__icon"
          />
        </a>

        <div class="right-side">
          <nav class="nav">
            <ul class="nav__list">
              <li class="nav__item">Mussum</li>
              <li class="nav__item">
                <a href="#testemunhos">Depoimentos</a>
              </li>
              <li class="nav__item">
                <a href="#planos"> Planos </a>
              </li>
              <li class="nav__item">
                <a href="#newsletter"> Newsletter </a>
              </li>
            </ul>
          </nav>

          <input class="header__input" type="text" />

          <button class="button-singIn" @click="openModalLogin">Entrar</button>
          <button class="button-singUp" @click="openModalCadastro">
            Cadastre-se
          </button>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  methods: {
    openModalLogin() {
      this.$router.push('/entrar?tab=0');
    },
    openModalCadastro() {
      this.$router.push('/entrar?tab=1');
    },
  },
};
</script>

<style lang="scss">
.homePage {
  #header {
    background: #1226aa;
    height: 80px;
    display: flex;
    color: white;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 100;

    .container {
      display: flex;
      max-width: 1138px;
      padding: 0 0px;
      width: 100%;
      margin: 0 auto;
      justify-content: space-between;

      .menu-mobile {
        display: none;
        cursor: pointer;
      }

      .header__link {
        .logo__icon {
          cursor: pointer;
          width: 137px;
        }
      }

      .right-side {
        display: flex;

        .nav {
          display: flex;
          justify-content: center;
          align-items: center;

          .nav__list {
            text-transform: uppercase;
            list-style: none;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;

            .nav__item {
              margin: 0 15px;
              cursor: pointer;

              &:hover {
                font-weight: 700;
                transform: scale(1.1);
              }
            }
          }
        }

        .header__input {
          width: 70px;
          height: 40px;
          padding: 10px 17px;
          border-radius: 90px;
          border: none;
          background: #3344b6 url('../../assets/icons/search.svg') right 17px
            center no-repeat;
          color: #fff;
          margin-right: 20px;
          margin: auto;
          transition: all 0.5s;

          &:focus {
            width: 360px;
            outline: none;
          }
        }

        button {
          width: 118px;
          height: 32px;
          margin: auto 0;
          border-radius: 80px;
          border: none;
          font-family: 'Roboto', sans-serif;
          cursor: pointer;
          font-size: 12px;

          &.button-singIn {
            background: transparent;
            color: #eaf7ff;
            border: 1px solid #eaf7ff;
            margin: auto 10px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .homePage {
    #header {
      height: 44px;
      padding: 0 12px;

      .container {
        .menu-mobile {
          display: flex;
        }
        .header__link {
          .logo__icon {
            display: none;
          }
        }

        .right-side {
          .nav {
            display: none;
          }

          .header__input {
            height: 24px;
          }

          button {
            width: 92px;
            height: 24px;
          }
        }
      }
    }
  }
}
</style>